var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d2-container-frame',{attrs:{"src":"http://help.suntrayoa.com/zh/"}})
}
var staticRenderFns = []

export { render, staticRenderFns }